import { useState } from 'react';
//import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://enqqmkzbihekepmwgkxy.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVucXFta3piaWhla2VwbXdna3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTMyOTMzMjMsImV4cCI6MjAwODg2OTMyM30.eq6c496Ujcsk_SaGYYpIZ-M4MsaoV0IPhCujRLfOWG8';

export default function Upload() {
  // const [path, setPath] = useState(''); // ← pathを保持するためのstate
  // const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

  // const handleFolderChange = async (e) => {
  //   const files = e.target.files;

  //   for (let i = 0; i < files.length; i++) {
  //     const file = files[i];
  //     const uploadPath = path + '/' + file.webkitRelativePath; // ← アップロード先のパスを動的に作成

  //     console.log(uploadPath);

  //     const { data, error } = await supabase.storage
  //       .from('kn1ght_public')
  //       .upload(uploadPath, file, {
  //         upsert: true,
  //       });

  //     if (error) {
  //       console.error('Error uploading file:', error);
  //       alert('エラーが発生しました: ' + error.message);
  //       break; // エラーが発生した場合、ループを終了
  //     }
  //   }

  //   console.log('完了');

  return (
    <></>
    // <>
    //   <div style={{ backgroundColor: '#fff', color: '#000' }}>
    //     <input
    //       type="text"
    //       placeholder="Path (e.g., /parent/child)"
    //       value={path}
    //       onChange={(e) => setPath(e.target.value.trim())}
    //     />
    //     {/* ← pathの入力フィールドを追加 */}
    //     <input type="file" directory="" webkitdirectory="" multiple onChange={handleFolderChange} />
    //   </div>
    // </>
  );
}
